__turbopack_context__.v({
  "stageBenefitsBox": "v3e5_G_stageBenefitsBox",
});
